import { message } from 'antd';
import Router from 'next/router';
import { adminUnmatch, createProjectFlags as createFlags, deleteProject } from '@gtintel/platform-api';
import { sendNotificationsAsAdmin } from '@gtintel/platform-firebase';
export function confirm() {
  this.setState({
    loading: true
  }, () => {
    deleteProject(this.props.query.id).then(() => {
      message.success('Project Deleted!');
      const {
        projects
      } = this.state;
      sendNotificationsAsAdmin({
        project: projects,
        content: 'deleted project',
        redirectLink: '/notification',
        sendToClient: true
      });
      setTimeout(() => {
        Router.push('/admin/project');
      }, 1000);
    }).catch(() => {
      this.setState({
        loading: false
      });
    });
  });
}
export function sendNotification(senderCancel, partnerID = '', partnerName = '') {
  const {
    selectPartner,
    selectPartnerName
  } = this.state;
  const {
    adminProjectDetailStore
  } = this.props;
  const {
    projectDetail
  } = adminProjectDetailStore;
  sendNotificationsAsAdmin({
    project: projectDetail,
    content: senderCancel ? 'removed you from the project' : 'invited you join project',
    redirectLink: senderCancel ? '#' : `/project/detail/${projectDetail.id}`,
    sendToCustomReceivers: [senderCancel ? {
      id: partnerID,
      name: partnerName
    } : {
      id: selectPartner,
      name: selectPartnerName
    }]
  });
}
export function unMatchPartner(partner_id, project_id) {
  const {
    getPartner
  } = this.state;
  adminUnmatch({
    partner_id,
    project_id
  }).then(response => {
    if (response.message) {
      message.success(response.message);
      Array.isArray(getPartner?.result) && getPartner.result.forEach(partner => {
        if (partner.id === partner_id) {
          partner.proposal_status = 1;
          this.sendNotification(true, partner_id, partner.full_name);
        }
      });
      this.setState({
        getPartner
      });
      window.location.reload();
    } else {
      message.error("Error: couldn't unmatch partner");
    }
  });
}
export function createProjectFlags(data) {
  this.setState({
    loading: true
  }, () => {
    createFlags(this.props.query.id, data).then(() => {
      message.success('ProjectFlags created!');
      setTimeout(() => {
        Router.reload();
      }, 1000);
    }).catch(() => {
      this.setState({
        loading: false
      });
    });
  });
}